import SkeletonBase from "newui/components/Skeleton";

interface RevisionsStepProps {
	rfxId: number;
	rfxSubmissionId?: number;
	isLoading?: boolean;
}

export const RevisionsStep: React.FC<RevisionsStepProps> = ({
	rfxId,
	rfxSubmissionId,
	isLoading = false,
}) => {
	if (isLoading) {
		return (
			<div className="space-y-3">
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
				<SkeletonBase startColor="lightgray" width="100%" height="48px" className="!rounded-lg" />
			</div>
		);
	}

	return (
		<div data-testid="revisions-step">
			<p className="text-sm text-gray-500 mb-4">
				Review any revised submissions that suppliers have provided following clarifications.
			</p>
			{/* TODO: Render revisions review interface when API is available */}
			<div className="rounded-lg border border-dashed border-gray-300 p-8 text-center text-gray-400 text-sm">
				Revised submissions review will appear here.
			</div>
		</div>
	);
};
